// ============================================================================
// Sound Manager for Notifications
// ============================================================================

let audioUnlocked = false;
let lastPlayTime = 0;
const THROTTLE_MS = 500; // Minimum time between sounds

/**
 * Unlock audio context on first user interaction.
 * Browsers require user interaction before playing audio.
 */
export function unlockAudio(): void {
  if (audioUnlocked) return;
  
  // Check if already unlocked in this session
  const stored = localStorage.getItem('notification_audio_unlocked');
  if (stored === 'true') {
    audioUnlocked = true;
    return;
  }
  
  // Unlock on first user interaction
  const unlock = () => {
    audioUnlocked = true;
    localStorage.setItem('notification_audio_unlocked', 'true');
    // Remove listeners after first unlock
    document.removeEventListener('click', unlock);
    document.removeEventListener('keydown', unlock);
    document.removeEventListener('touchstart', unlock);
  };
  
  document.addEventListener('click', unlock, { once: true });
  document.addEventListener('keydown', unlock, { once: true });
  document.addEventListener('touchstart', unlock, { once: true });
}

/**
 * Play notification sound.
 * Only plays for real-time notifications (not initial page load).
 * Throttled to prevent rapid-fire sounds.
 */
export function playNotificationSound(): void {
  // Ensure audio is unlocked
  if (!audioUnlocked) {
    unlockAudio();
    return; // Can't play until unlocked
  }
  
  // Throttle: don't play if too soon after last play
  const now = Date.now();
  if (now - lastPlayTime < THROTTLE_MS) {
    return;
  }
  
  lastPlayTime = now;
  
  try {
    // Use the notification.mp3 file from the project root
    // In production, this should be in public/notification.mp3
    const audio = new Audio('/notification.mp3');
    audio.volume = 0.7; // Set volume to 70%
    
    // Play and handle errors silently
    audio.play().catch(() => {
      // Silently fail if audio can't play (e.g., user hasn't interacted yet)
    });
  } catch {
    // Silently fail if Audio API is not available
  }
}





